<script lang="ts" setup>

import {useRoute, type RouteLocationRaw} from 'vue-router';
import {computed, ref, watchEffect} from 'vue';
import {useNavigationOriginStore} from '@/ts/store/navigation-origin.store';

const props = defineProps<{
  to: RouteLocationRaw;
  originPageTitle: string;
}>();

const navigationOriginStore = useNavigationOriginStore();
const originId = ref<string>();

const to = computed((): RouteLocationRaw => {
  const originQuery = {
    ...(originId.value ? {origin: originId.value} : {}),
  };

  if (typeof props.to === 'string') {
    const toIncludesQueryParams = props.to.includes('?');
    const separator = toIncludesQueryParams ? '&' : '?';
    return props.to + separator + new URLSearchParams(originQuery).toString();
  }

  return {
    ...props.to,
    query: {
      ...(props.to.query ?? {}),
      ...originQuery,
    },
  };
});

const {fullPath} = useRoute();
watchEffect(() => {
  originId.value = navigationOriginStore.createOriginId(fullPath, props.originPageTitle);
});

</script>

<template>
  <router-link :to="to" class="router-link-with-origin">
    <slot name="default"/>
  </router-link>
</template>

<style lang="scss" scoped>
.router-link-with-origin {
  display: block;
  border-radius: var(--Border-Radius-3);

  &:focus-visible {
    outline: 2px solid var(--Primary-primary-color-1);
    outline-offset: 2px;
  }
}
</style>